import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

import { withStyles } from '@material-ui/core/styles';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'

const styles = theme => ({
    expansionPanel: {
        borderBottom: '1px solid ' + theme.palette.secondary.light,
    },
    panelHeader: {
        background: theme.palette.secondary.main,
    },
    panelHeaderContent: {
        alignItems: 'center'
    },
    headingText: {
        color: '#FFF',
        flex: 1
    },
    headingIcon: {
        color: '#FFF',
    },
    assignedUser: {
        flex: 1
    }
});
const primaryButton = 0;
const keyCodes = {
    enter: 13,
    escape: 27,
    arrowDown: 40,
    arrowUp: 38,
    tab: 9,
};

class BacklogTask extends React.Component {

    onKeyDown = (event, provided, snapshot) => {
        if (provided.dragHandleProps) {
            provided.dragHandleProps.onKeyDown(event);
        }

        if (event.defaultPrevented) {
            return;
        }

        if (snapshot.isDragging) {
            return;
        }

        if (event.keyCode !== keyCodes.enter) {
            return;
        }

        // we are using the event for selection
        event.preventDefault();

        const wasMetaKeyUsed = event.metaKey;
        const wasShiftKeyUsed = event.shiftKey;

        this.performAction(wasMetaKeyUsed, wasShiftKeyUsed);
    };

    // Using onClick as it will be correctly
    // preventing if there was a drag
    onClick = (event) => {
        if (event.defaultPrevented) {
            return;
        }

        if (event.button !== primaryButton) {
            return;
        }

        // marking the event as used
        event.preventDefault();

        const wasMetaKeyUsed = event.metaKey;
        const wasShiftKeyUsed = event.shiftKey;

        this.performAction(wasMetaKeyUsed, wasShiftKeyUsed);
    };

    onTouchEnd = (event) => {
        if (event.defaultPrevented) {
            return;
        }

        // marking the event as used
        // we would also need to add some extra logic to prevent the click
        // if this element was an anchor
        event.preventDefault();
        this.props.toggleSelectionInGroup(this.props.task.id);
    };

    performAction = (wasMetaKeyUsed, wasShiftKeyUsed) => {
        const {
            task,
            toggleSelection,
            toggleSelectionInGroup,
            multiSelectTo,
        } = this.props;

        if (wasMetaKeyUsed) {
            toggleSelectionInGroup(task.id);
            return;
        }

        if (wasShiftKeyUsed) {
            multiSelectTo(task.id);
            return;
        }

        toggleSelection(task.id);
    };

    render() {
        const { classes, task, index } = this.props;
        return (<Draggable draggableId={task.id} index={index}>
            {(provided, snapshot) => {
                return (
                    <div ref={provided.innerRef} {...provided.draggableProps}  {...provided.dragHandleProps}
                        onClick={this.onClick} onKeyDown={(event) => this.onKeyDown(event, provided, snapshot)}>
                        <ExpansionPanel classes={{ root: classes.expansionPanel }}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon className={classes.headingIcon} />
                            } classes={{ root: classes.panelHeader, content: classes.panelHeaderContent }}>
                                <Typography className={classes.headingText}> {task.name}</Typography>
                                {
                                    task.user && 
                                    <AssignmentIndIcon className={classes.headingIcon} />
                                }
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Typography>{task.details}</Typography>
                            </ExpansionPanelDetails>
                            <Divider />
                            <ExpansionPanelActions>
                                {
                                    task.user && 
                                    <Typography className={classes.assignedUser}>{task.user.firstName} {task.user.lastName}</Typography>
                                }
                                <Button size="small" onClick={this.onClick}>Edit</Button>
                                <Button size="small" color="primary" onClick={e => this.props.userAssignmentHandler(task)}>Claim</Button>
                            </ExpansionPanelActions>
                        </ExpansionPanel>
                    </div>)

            }}
        </Draggable>)
    }
}

BacklogTask.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles, { withTheme: true })(BacklogTask);


// WEBPACK FOOTER //
// ./src/Components/Presentation/BacklogTasks/BacklogTask.js